/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchOverlapStatus,
  KillswitchOverlapStatus$inboundSchema,
} from "./killswitchoverlapstatus.js";
import {
  KillswitchSchedule,
  KillswitchSchedule$inboundSchema,
} from "./killswitchschedule.js";
import {
  KillswitchScope,
  KillswitchScope$inboundSchema,
} from "./killswitchscope.js";

export type KillswitchOverlap = {
  id: string;
  schedule: KillswitchSchedule;
  scope: KillswitchScope;
  status: KillswitchOverlapStatus;
};

/** @internal */
export const KillswitchOverlap$inboundSchema: z.ZodMiniType<
  KillswitchOverlap,
  unknown
> = z.object({
  id: z.string(),
  schedule: KillswitchSchedule$inboundSchema,
  scope: KillswitchScope$inboundSchema,
  status: KillswitchOverlapStatus$inboundSchema,
});

export function killswitchOverlapFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchOverlap, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchOverlap$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchOverlap' from JSON`,
  );
}
